import axios from "axios";
import getToken from '../helpers/getToken.js';

const backendUrlPost = process.env.REACT_APP_BACKEND_RESUME_URL;

const PostResumeSchemaless = async (postBody, userInfo) => {
  const token = getToken();
  const postB = JSON.parse(postBody)
  postB.data = userInfo

  const headers = {
      "Content-Type": "application/json",
      token: token,
  };
  try {
      const response = await axios.post(
          `${backendUrlPost}/schemaless`,
          postB,
          { headers }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export default PostResumeSchemaless;
